import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import React from 'react';
import styled from 'styled-components';

type LinkButtonProps =
  | {
      type?: 'button';
      primary?: boolean;
    }
  | ({
      type: 'anchor';
    } & React.AnchorHTMLAttributes<HTMLAnchorElement>);

const Button = styled.button.attrs({
  type: 'button'
})<{ primary?: boolean }>`
  font-size: 16px;
  text-decoration: underline;
  background: none;
  border: none;
  box-shadow: none;
  color: ${({ primary }) => (primary ? colors.brown : colors.blueGrey)};
  cursor: pointer;
  padding: 0;
  font-family: inherit;
  line-height: inherit;
  letter-spacing: inherit;
`;

const Anchor = styled.a`
  transition: all 0.5s ease-out;
  display: inline-block;
  text-decoration: none;
  font-family: VIC;
  box-sizing: border-box;
  vertical-align: middle;
  word-break: break-all;
  flex-wrap: nowrap;
  min-height: 50px;
  cursor: pointer;
  border-radius: 2px;
  background-color: ${colors.orange};
  border: solid 1px ${colors.orange};

  font-size: 1.2rem;
  font-weight: 700;
  line-height: 50px;
  letter-spacing: -0.3px;
  text-align: center;
  color: ${colors.white};

  &:focus,
  &::-moz-focus-inner {
    border: none;
  }

  @media ${device.isTablet}, ${device.isDesktop} {
    padding-left: 13px;
    padding-right: 13px;
    min-width: 160px;
  }

  @media ${device.isMobile} {
    min-width: 200px;
    width: 100%;
  }

  :hover,
  :focus {
    border: solid 1px ${colors.brown};
    background-color: ${colors.brown};
  }
`;

const LinkButton: React.FC<LinkButtonProps> = props => {
  if (!props.type || props.type === 'button') {
    return <Button {...props} />;
  }

  return <Anchor {...props} />;
};

export default LinkButton;
